import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, WrapItem, Tooltip } from '@chakra-ui/react';

export default function InsightsPanelTable({ data, title, column1Heading = "Column 1", column2Heading = "Column 2", column2HeadingTooltip }) {
    return (
        <Box overflowX="auto" border="1px" borderColor="gray.200" borderRadius="md">
            {title && (
                <Text 
                    fontSize="sm" 
                    fontWeight="bold" 
                    p={0} 
                    borderBottom="1px" 
                    borderColor="gray.200"
                    backgroundColor="gray.50"
                    // Center the text
                    textAlign="center"
                >
                    {title}
                </Text>
            )}
            <Table variant="simple" size="sm">
                <Thead>
                    <Tr>
                        <Th>{column1Heading}</Th>
                        <WrapItem>
                            <Tooltip
                                label={column2HeadingTooltip}
                                isDisabled={!column2HeadingTooltip}
                            >
                                <Th>{column2Heading}</Th>
                            </Tooltip>
                        </WrapItem>
                    </Tr>
                </Thead>
                <Tbody>
                    {data.map((row, index) => (
                        <Tr key={index} _hover={{ bg: 'gray.50' }}>
                            <Td>{row.col1}</Td>
                            <Td>{row.col2}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </Box>
    );
}
